import React from 'react';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import ECardNewFilesListItem from './ECardNewFilesListItem';
import { ECardNewFileSelectedItem } from './ECardNewFilesListWrapper';

interface Props {
	flatData: any[];
	onLoadMore: () => void;
	onRefresh: () => void;
	isLoading: boolean;
	hasMoreData: boolean;
	isAllSelected: boolean;
	onItemSelect: (item: ECardNewFileSelectedItem, add: boolean) => void;
}

const WRAPPER_ID = 'eCardNewFilesList';

const ECardNewFilesList: React.FC<Props> = ({
	flatData,
	onLoadMore,
	onRefresh,
	isLoading,
	hasMoreData,
	isAllSelected,
	onItemSelect,
}) => {
	return (
		<ScrollContainer wrapperId={WRAPPER_ID}>
			<FlatList
				onRefresh={onRefresh}
				onLoadMore={onLoadMore}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={WRAPPER_ID}
				itemKey={'id'}
				renderItem={item => (
					<ECardNewFilesListItem
						item={item}
						onSelect={onItemSelect}
						isSelected={isAllSelected}
						afterFileTransfer={onRefresh}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default ECardNewFilesList;
